import { validateNumber } from '../../../../utils';
import { NumberInputDefinition } from '../../../../types';

// number input validation
export default (input: NumberInputDefinition, errors: string[]) => {
  const { settings: { minValue, maxValue } = {} } = input;
  validateNumber(errors, minValue, maxValue);
};
